module.exports = __webpack_public_path__ + "img/istockphoto-1246562124-612x612.b0d69354.jpg";